import ModelFactory from '../../model-factory';
import BaseModel from '../../models/base-model';

export default class Export extends BaseModel {
  constructor(data = {}) {
    super(data);
  }
}

export const modelFactory = new ModelFactory('export', (data) => new Request(data));
